import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from '@mui/material';

const ActionButtons = ({
  selectedDataPoint,
  handleOpenDeleteDialog,
  isDeleteDialogOpen,
  handleCloseDeleteDialog,
  handleConfirmDelete,
  handleSubmit,
  behaviorId,
  isDisabled,
  isDeleting,
  fromSessionNotes,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      mt: 2,
      gap: 2,
    }}
  >
    {selectedDataPoint && !fromSessionNotes && (
      <>
        <Button
          variant='contained'
          color='error'
          sx={{
            textTransform: 'capitalize',
          }}
          onClick={handleOpenDeleteDialog}
          disabled={isDeleting || isDisabled}
          startIcon={
            isDeleting ? <CircularProgress size={16} color='inherit' /> : null
          }
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>

        <Dialog open={isDeleteDialogOpen} onClose={handleCloseDeleteDialog}>
          <DialogTitle fontWeight={'bold'} fontFamily={'Lato'}>
            Confirm Deletion
          </DialogTitle>
          <DialogContent>
            <DialogContentText fontFamily={'Lato'}>
              Are you sure you want to delete this QuickTrack data entry
              permanently?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant='outlined'
              onClick={handleCloseDeleteDialog}
              color='primary'
              sx={{
                color: 'var(--clr-theme-purple)',
                border: '1px solid var(--clr-theme-purple)',
              }}
            >
              No
            </Button>
            <Button
              onClick={handleConfirmDelete}
              variant='contained'
              color='error'
              autoFocus
              disabled={isDeleting}
              startIcon={
                isDeleting ? (
                  <CircularProgress size={16} color='inherit' />
                ) : null
              }
            >
              {isDeleting ? 'Deleting...' : 'Yes'}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    )}
    {!fromSessionNotes && (
      <Button
        variant='contained'
        sx={{
          textTransform: 'capitalize',
          backgroundColor: 'var(--clr-mindly-purple-hover)!important',
          '&.Mui-disabled': {
            backgroundColor: '#d3d3d3 !important',
            color: '#808080 !important',
          },
        }}
        onClick={() => handleSubmit(behaviorId)}
        disabled={isDisabled}
        startIcon={
          isDisabled ? <CircularProgress size={16} color='inherit' /> : null
        }
      >
        {isDisabled
          ? selectedDataPoint
            ? 'Updating...'
            : 'Saving...'
          : selectedDataPoint
          ? 'Update'
          : 'Save'}
      </Button>
    )}
  </Box>
);

export default ActionButtons;
